import axios from "axios";

export async function GetAccounts() {
  const response = await axios.get("/api/v1.0/account");
  return response.data;
}

export async function GetAccountTypeMaps() {
  const response = await axios.get("/api/v1.0/account/accounttypemap");
  return response.data;
}

export async function GetWbCompanies() {
  const response = await axios.get("/api/v1.0/wbcompany");
  return response.data;
}

export async function GetDepartments() {
  const response = await axios.get("/api/v1.0/department");
  return response.data;
}

export async function GetStrategies() {
  const response = await axios.get("/api/v1.0/strategy");
  return response.data;
}
